<div
  class="drill-block"
  role="button"
  tabindex="0"
  [style.background-color]="color()"
  [attr.aria-label]="session().equipmentLabel + ' · ' + session().operatorLabel + ' — ' + session().drilledMeters + 'm drilled'"
  [title]="tooltip()"
  (click)="blockClick.emit(session())"
  (keydown.enter)="blockClick.emit(session())"
  (keydown.space)="blockClick.emit(session())"
>
  <span class="block-line1">{{ session().equipmentLabel }}</span>
  <span class="block-line2">{{ session().drilledMeters }}m</span>
</div>
